import api from 'api';

export const loadEvents = api(
  'GET /api/integrations/conversions/fields/events'
);

export const loadAffiliates = api(
  'GET /api/integrations/conversions/fields/affiliates'
);

export const loadPlatforms = api(
  'GET /api/integrations/conversions/fields/platforms'
);

export const loadApplications = api(
  'GET /api/integrations/conversions/fields/applications'
);

export const loadNetworks = api(
  'GET /api/integrations/conversions/fields/networks'
);

export const loadClusters = api(
  'GET /api/integrations/conversions/fields/clusters'
);

export const loadPartners = api(
  'GET /api/integrations/conversions/fields/partners'
);

export const loadTrafficTypes = api(
  'GET /api/integrations/conversions/fields/traffic-types'
);

export const loadActivityTypes = api(
  'GET /api/integrations/conversions/fields/activity-types'
);
export const loadRegistrationCountries = api(
  'GET /api/integrations/conversions/fields/registration-countries'
);

export const loadEventCountries = api(
  'GET /api/integrations/conversions/fields/event-countries'
);

export const loadChannels = api(
  'GET /api/integrations/conversions/fields/affiliatechannels'
);
